<template>
<div class="password-input">
  <input :type="show?'text':'password'" :placeholder="placeholder" :value="value" @input="$emit('input',$event.target.value)">
  <div class="pwd-btn" :class="{show}" @click="show=!show"></div>
</div>
</template>

<script>
export default {
  props:{
    value:null,
    placeholder:null,
  },
  data() {
    return {
      show:false
    };
  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.password-input {
  position: relative;
  height: 100%;
  input {
    width: 100%;
    height: 100%;
    padding-right: 50px;
    text-align: left !important;
  }
  .pwd-btn {
    width: 46px;
    height: 46px;
    background: url("~static/images/pwd-hide.png") no-repeat;
    background-size: 100%;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    &.show {
      background-image: url("~static/images/pwd-show.png");
    }
  }
}
</style>
